import React, { Component } from 'react'
import { productsService } from '../../_services/products.service'
import { Dropdown } from 'semantic-ui-react'

class AsyncProductSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      defaultValue: this.props.defaultValue || undefined,
      brandId: this.props.brandId,
      categoryId: this.props.categoryId,
      categoryType: this.props.categoryType,
      categoryHelperType: this.props.categoryHelperType,
      globalIndexesForRelatedProducts: this.props.globalIndexesForRelatedProducts,
      data: []
    }
  }

  componentDidMount() {
    this.getData()
  }

  // async componentWillReceiveProps(nextProps) {
  //   console.log(nextProps.defaultValue);

  //   if (nextProps.defaultValue !== this.state.defaultValue) {
  //     this.setState({ defaultValue: nextProps.defaultValue });

  //   }
  //   if (nextProps.categoryType !== this.state.categoryType) {
  //     this.setState({ categoryType: nextProps.categoryType }, () => {
  //       this.getData();
  //     });
  //   }
  // }

  getData() {
    if (this.state.brandId && this.state.brandId !== '00000000-0000-0000-0000-000000000000' && this.state.categoryHelperType != undefined) {
      // console.log('here')
      this.setState({ loading: true })
      productsService
        .getAllByBrandAndCategoryHelperType(this.state.brandId, this.state.categoryHelperType)
        .then(res => {
          let data = res.data.map(elm => ({
            text:
              elm.name +
              (this.props.withCategory && elm.category
                ? ' (' + elm.category.name + ')'
                : ''),
            value: elm.id,
            measurementType: elm.measurementType,
            subMeasurementType: elm.subMeasurementType,
            conversionUnit: elm.conversionUnit,
            quantity: elm.quantity
          }))
          this.setState({ data: data, loading: false, isSubmitting: false })
        })
        .catch(error => {
          this.setState({ loading: false })
          console.log(error)
        })
    } else if (this.state.categoryId && this.state.categoryId !== '00000000-0000-0000-0000-000000000000' && this.state.brandId && this.state.brandId !== '00000000-0000-0000-0000-000000000000') {
      // console.log('here')
      this.setState({ loading: true })
      productsService
        .getAllByCategoryAndBrand(this.state.categoryId, this.state.brandId)
        .then(res => {
          let data = res.data.map(elm => ({
            text:
              elm.name +
              (this.props.withCategory && elm.category
                ? ' (' + elm.category.name + ')'
                : ''),
            value: elm.id,
            measurementType: elm.measurementType,
            subMeasurementType: elm.subMeasurementType,
            conversionUnit: elm.conversionUnit,
            quantity: elm.quantity
          }))
          this.setState({ data: data, loading: false, isSubmitting: false })
        })
        .catch(error => {
          this.setState({ loading: false })
          console.log(error)
        })
    } else if (this.state.categoryType != undefined && this.state.brandId && this.state.brandId !== '00000000-0000-0000-0000-000000000000') {
      
      this.setState({ loading: true })
      productsService
        .getAllByCategoryTypeAndBrand(
          this.state.categoryType,
          this.state.brandId
        )
        .then(res => {
          let data = res.data.map(elm => ({
            text:
              elm.name +
              (this.props.withCategory && elm.category
                ? ' (' + elm.category.name + ')'
                : ''),
            value: elm.id,
            measurementType: elm.measurementType,
            subMeasurementType: elm.subMeasurementType,
            conversionUnit: elm.conversionUnit,
            quantity: elm.quantity
          }))
          this.setState({ data: data, loading: false, isSubmitting: false })
        })
        .catch(error => {
          this.setState({ loading: false })
          // console.log(error)
        })
    } else if (this.state.categoryType != undefined && this.state.categoryHelperType != undefined  && this.state.globalIndexesForRelatedProducts) {
      
      this.setState({ loading: true })
      productsService
        .getAllByCategoryTypeAndcategoryHelperTypeAndLoadGlobalIndexesForRelatedProducts(
          this.state.categoryType,
          this.state.categoryHelperType,
          this.state.globalIndexesForRelatedProducts,
        )
        .then(res => {
          let data = res.data.map(elm => ({
            text:
              elm.name +
              (this.props.withCategory && elm.category
                ? ' (' + elm.category.name + ')'
                : ''),
            value: elm.id,
            measurementType: elm.measurementType,
            subMeasurementType: elm.subMeasurementType,
            conversionUnit: elm.conversionUnit,
            quantity: elm.quantity
          }))
          this.setState({ data: data, loading: false, isSubmitting: false })
        })
        .catch(error => {
          this.setState({ loading: false })
          // console.log(error)
        })
    } else if (this.state.categoryType != undefined && this.state.categoryHelperType != undefined) {
      console.log("categoryHelperType");
      this.setState({ loading: true })
      productsService
        .getAllByCategoryTypeAndBrand(
          this.state.categoryType,
          this.state.brandId
        )
        .then(res => {
          let data = res.data.map(elm => ({
            text:
              elm.name +
              (this.props.withCategory && elm.category
                ? ' (' + elm.category.name + ')'
                : ''),
            value: elm.id,
            measurementType: elm.measurementType,
            subMeasurementType: elm.subMeasurementType,
            conversionUnit: elm.conversionUnit,
            quantity: elm.quantity
          }))
          this.setState({ data: data, loading: false, isSubmitting: false })
        })
        .catch(error => {
          this.setState({ loading: false })
          // console.log(error)
        })
    }
  }

  async componentWillReceiveProps(nextProps) {
    console.log(nextProps);
    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue })
    }
    if (nextProps.categoryId !== this.state.categoryId && nextProps.categoryId !== '00000000-0000-0000-0000-000000000000') {
      this.setState({ categoryId: nextProps.categoryId, data: [] }, () => {
        this.getData()
      })
    }
    if (nextProps.brandId !== this.state.brandId && nextProps.brandId !== '00000000-0000-0000-0000-000000000000') {
      this.setState({ brandId: nextProps.brandId, data: [] }, () => {
        this.getData()
      })
    }
    if (nextProps.categoryType != undefined && nextProps.categoryType !== this.state.categoryType) {
      this.setState({ brandId: nextProps.categoryType, data: [] }, () => {
        this.getData()
      })
    }
    if (nextProps.categoryHelperType != undefined && nextProps.categoryHelperType !== this.state.categoryHelperType) {
      this.setState({ brandId: nextProps.categoryHelperType, data: [] }, () => {
        this.getData()
      })
    }
    if (nextProps.globalIndexesForRelatedProducts != undefined && nextProps.globalIndexesForRelatedProducts !== this.state.globalIndexesForRelatedProducts) {
      this.setState({ brandId: nextProps.globalIndexesForRelatedProducts, data: [] }, () => {
        this.getData()
      })
    }
  }

  handleChange = e => {
    let selected = e
    this.setState({ selected: selected })
    let item = this.state.data.filter(el => el.value === selected)[0]
    this.props.onChange(item)
    console.log(item)
  }

  handleSearchChange = e => {
    // const {categoryId, brandId} = this.state;
  }

  componentWillUnmount() {
    this.setState({
      categoryId: undefined,
      brandId: undefined,
      selected: undefined,
      data: [],
      value: undefined,
      defaultValue: undefined,
      categoryType: undefined
    })
  }

  render() {
    const { data, loading, defaultValue, disabled } = this.state
    const { clearable, className } = this.props

    return (
      <Dropdown
        placeholder=""
        fluid
        search
        selection
        basic
        onChange={(e, d) => this.handleChange(d.value)}
        value={defaultValue}
        onSearchChange={(e, d) => this.handleSearchChange(e.target.value)}
        className={className}
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
        noResultsMessage="رکوردی یافت نشد"
        direction="right"
      />
    )
  }
}
export default AsyncProductSelect
